import { createSlice } from '@reduxjs/toolkit'

import { JOBS_FILTERS_INITIAL_VALUES } from 'features/job/consts/filters'

const initialState = {
  list: [],
  loading: false,
  error: null,
  page: 1,
  meta: null,

  filters: {
    ...JOBS_FILTERS_INITIAL_VALUES,
  },
}

const jobJobsSpecificListSlice = createSlice({
  name: 'jobJobsSpecificList',
  initialState,
  reducers: {
    getList(state) {
      state.loading = true
      state.error = null
    },
    getListSuccess(state, action) {
      state.loading = false
      state.list = action.payload.data
      state.meta = action.payload.meta
    },
    getListError(state, action) {
      state.loading = false
      state.error = action.payload
    },
    setPage(state, action) {
      state.page = action.payload
    },
    updateListItem(state, action) {
      state.list = state.list.map(item => {
        if (item.id === action.payload.id) {
          return {
            ...item,
            ...action.payload,
          }
        } else {
          return item
        }
      })
    },
    changeFilter(state, action) {
      state.page = 1
      state.filters = { ...state.filters, ...action.payload }
    },
    resetFilter(state) {
      state.filters = initialState.filters
    },
    resetDataState(state) {
      return {
        ...state,
        list: [],
        loading: false,
        error: null,
        page: 1,
        meta: null,
      }
    },
    cleanState() {
      return initialState
    },
  },
})
/**
 * @namespace
 * @property {function} getList
 * @property {function} getListSuccess
 * @property {function} getListError
 * @property {function} setPage
 * @property {function} updateListItem
 * @property {function} changeFilter
 * @property {function} resetFilter
 * @property {function} resetDataState
 * @property {function} cleanState
 */

export const jobJobsSpecificList = jobJobsSpecificListSlice.actions

export default jobJobsSpecificListSlice.reducer
